import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.allList>>;

export const createFetchAllOrganizationsQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) =>
    (await call(() => cancelOnSignal(AdminService.getAllOrganizationsList(), signal))) ?? [];
